import { CARD_LIMIT } from './Data';

export const URL_GET_LIST_LUCKY_SPOT = `/wispet-lucky-spots?_limit=${CARD_LIMIT}&_order=a-z%(params)s`;
export const URL_DETAIL_LUCKY_SPOT = `/wispet-lucky-spots/%(id)s`;
export const URL_LUCKY_SPOT = `/wispet-lucky-spots`;
export const URL_OPT_WISPET_MERCHANT = `/wispet-merchants?_limit=${
   CARD_LIMIT + 30
}%(params)s`;
export const URL_OPT_WISPET_MERCHANT_CATEGORY = `/wispet-merchant-categories?_limit=${
   CARD_LIMIT + 30
}%(params)s`;
export const URL_OPT_PROVINCE = `/provinces?_limit=${CARD_LIMIT + 30}%(params)s`;
export const URL_OPT_REGENCY_BY_PROVINCE = `/provinces/%(id)s/regencies?_limit=${
   CARD_LIMIT + 30
}%(params)s`;
export const URL_OPT_DISTRICT_BY_REGENCY = `/regencies/%(id)s/districts?_limit=${
   CARD_LIMIT + 30
}%(params)s`;

export const type = {
   GET_LIST_LUCKY_SPOT_LOADING: 'GET_LIST_LUCKY_SPOT_LOADING',
   GET_LIST_LUCKY_SPOT_SUCCESS: 'GET_LIST_LUCKY_SPOT_SUCCESS',
   GET_LIST_LUCKY_SPOT_FAILED: 'GET_LIST_LUCKY_SPOT_FAILED',

   GET_DETAIL_LUCKY_SPOT_LOADING: 'GET_DETAIL_LUCKY_SPOT_LOADING',
   GET_DETAIL_LUCKY_SPOT_SUCCESS: 'GET_DETAIL_LUCKY_SPOT_SUCCESS',
   GET_DETAIL_LUCKY_SPOT_FAILED: 'GET_DETAIL_LUCKY_SPOT_FAILED',

   CREATE_LUCKY_SPOT_LOADING: 'CREATE_LUCKY_SPOT_LOADING',
   CREATE_LUCKY_SPOT_SUCCESS: 'CREATE_LUCKY_SPOT_SUCCESS',
   CREATE_LUCKY_SPOT_FAILED: 'CREATE_LUCKY_SPOT_FAILED',

   UPDATE_LUCKY_SPOT_LOADING: 'UPDATE_LUCKY_SPOT_LOADING',
   UPDATE_LUCKY_SPOT_SUCCESS: 'UPDATE_LUCKY_SPOT_SUCCESS',
   UPDATE_LUCKY_SPOT_FAILED: 'UPDATE_LUCKY_SPOT_FAILED',

   DELETE_LUCKY_SPOT_LOADING: 'DELETE_LUCKY_SPOT_LOADING',
   DELETE_LUCKY_SPOT_SUCCESS: 'DELETE_LUCKY_SPOT_SUCCESS',
   DELETE_LUCKY_SPOT_FAILED: 'DELETE_LUCKY_SPOT_FAILED',
};
